/*
 * @Author: changdou.fe@bytedance.com
 * @Date: 2025-08-02 19:26:26
 * @LastEditors: changdou.fe@bytedance.com
 * @LastEditTime: 2025-08-30 23:49:09
 */
import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { message, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { convertAddress } from '@/lib/utils';

const CopyText = ({
  text = '',
  color = '#fff',
  className,
  svgClassName,
  showText = false,
  full = false,
  useToast = true,
  showHoverText = true,
  onCopy,
  iconSize = 3,
}: {
  text: string;
  color?: string;
  className?: string;
  svgClassName?: string;
  showText?: boolean;
  /** 原样展示，不截断地址 */
  full?: boolean;
  /** 复制后是否用 toast 提示，false 则显示 Check 图标 3s 后恢复 */
  useToast?: boolean;
  /** hover 时是否展示复制提示 Tooltip，默认 true */
  showHoverText?: boolean;
  /** 复制成功回调 */
  onCopy?: () => void;
  /** 图标大小（tailwind 数值），默认 3 即 w-3 h-3 */
  iconSize?: number;
}) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const handleCopyAddress = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(text);
      onCopy?.();
      if (useToast) {
        message.success(t('copy.success'));
      } else {
        setCopied(true);
        setTimeout(() => setCopied(false), 3000);
      }
    } catch (err) {
      message.error(t('copy.failed'));
    }
  };

  if (!text) {
    return null;
  }

  const sizeClass = `w-${iconSize} h-${iconSize}`;
  const IconComp = copied ? Check : Copy;
  const iconClass = copied
    ? `${sizeClass} text-green-500 ${svgClassName || ''}`
    : `${sizeClass} text-[${color}] text-font-secondary hover:text-font-primary cursor-pointer ${svgClassName || ''}`;

  // 新功能，逐步迁移
  if (showText) {
    const _text = full ? text : convertAddress({ str: text });
    const icon = <IconComp className={iconClass} onClick={copied ? undefined : handleCopyAddress} />;
    return (
      <span className={`flex items-center gap-1 ${className}`}>
        <span>{_text}</span>
        {showHoverText ? <Tooltip title={t('copy.tooltip')}>{icon}</Tooltip> : icon}
      </span>
    );
  }
  // 历史逻辑，迁移到新功能后，逐步删除
  const icon = (
    <IconComp
      className={copied ? `${sizeClass} text-green-500 ${className}` : `${sizeClass} text-[${color}] text-font-secondary hover:text-font-primary cursor-pointer ${className}`}
      onClick={copied ? undefined : handleCopyAddress}
    />
  );
  return showHoverText ? <Tooltip title={t('copy.tooltip')}>{icon}</Tooltip> : icon;
};

export default CopyText;
